import { FC } from "react";
import { LoadingButton } from "@mui/lab";
import { Button, Stack } from "@mui/material";
import { IntegrationFormActionsProps } from "@/components/pages/integrations/components/communications/common/components/drawer/form/CommunicationIntegrationFormActions";
import { useAppAbility } from "@/services/permissions";

interface JiraTestConnectActionProps {
  isLoading: boolean;
  connected: boolean;
  failed: boolean;
  disabled: boolean;
  onConnect(): void;
  formActionProps: IntegrationFormActionsProps;
}

export const JiraFormActions: FC<JiraTestConnectActionProps> = ({
  onConnect,
  isLoading,
  connected,
  failed,
  disabled,
  formActionProps,
}) => {
  const { cannot } = useAppAbility();
  const canNotCreateIntegration = cannot("create", "integration");
  const canNotEditIntegration = cannot("edit", "integration");

  return (
    <Stack spacing={2} alignItems="start">
      <Stack direction="row" spacing={2} py={0.5}>
        {connected && !failed ? (
          <LoadingButton
            onClick={formActionProps.onSubmit}
            disabled={
              canNotCreateIntegration ||
              canNotEditIntegration ||
              formActionProps.disabled
            }
            loading={formActionProps.loading}
            variant="contained"
          >
            Create
          </LoadingButton>
        ) : (
          <LoadingButton
            variant="contained"
            loading={isLoading}
            disabled={disabled}
            onClick={onConnect}
          >
            Test Connect
          </LoadingButton>
        )}

        <Button
          disabled={isLoading}
          onClick={formActionProps.onCancel}
          color="tertiary"
        >
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
};
